<template>
  <div
    v-if="request.requestType === 'TRK'"
    class="mt-3"
  >
    <div class="mb-2">
      <span>{{ $t('trkExtrasView.balanc') }} </span>
      <span class="text-dark">{{ requestExtras.pickupCountry }}, {{ requestExtras.pickupCity }} </span>
    </div>

    <div class="mb-2">
      <span>{{ $t('trkExtrasView.boaldmaYeri') }} </span>
      <span class="text-dark">{{ requestExtras.dropOffCountry }}, {{ requestExtras.dropOffCity }}</span>
    </div>

    <div class="mb-2">
      <span>{{ $t('trkExtrasView.yolaDmTarixi') }} </span>
      <span class="text-dark">{{ requestExtras.offerDeadline }}</span>
    </div>



    <div
      v-if="truckType"
      class="mb-3"
    >
      <span>{{ $t('trkExtrasView.trnNv') }}</span>
      <div class="text-dark">
        <strong>{{ truckType.name }}</strong> <br>
        <span>{{ truckType.description }}</span>
      </div>
    </div>
    <div class="mb-3">
      <span>{{ $t('trkExtrasView.qbulEdilnYkNvlri') }}</span>
      <div
        v-for="t in requestExtras.types.split(',')"
        :key="t"
        class="text-dark"
      >
        - {{ getLoadTypeName(t) }}
        <span v-if="t==='dangerous'">
          <span
            v-if="requestExtras.driverHasAdr>0"
            class="text-success"
          >
            {{ $t('trkExtrasView.srcnnAdrIcazsiVar') }}
          </span>
          <span
            v-else
            class="text-danger"
          >
            {{ $t('trkExtrasView.srcnnAdrIcazsiYoxdur') }}
          </span>
        </span>
      </div>
    </div>

    <div class="mb-2">
      <span>{{ $t('trkExtrasView.qbulEdilBilckYkHcmi') }} </span>
      <span class="text-dark">{{ requestExtras.volume }} {{ requestExtras.unit }}</span>
    </div>

    <div class="mb-2">
      <span>{{ $t('trkExtrasView.danmaQiymti') }} </span>
      <span class="text-dark">
        {{ $t('trkExtrasView.nAzn', {priceVolume: requestExtras.priceVolume, unit: requestExtras.unit, pricePrice: requestExtras.pricePrice}) }}
        <span v-if="requestExtras.priceNotes">
          <br> {{ requestExtras.priceNotes }}
        </span>
      </span>
    </div>
  </div>
</template>
<script>
import {getLoadTypeName, truckTypes} from "@/repositories/Utils";

export default {
  name: 'TRKExtrasView',
  props: {
    request: {},
    requestExtras:  {}
  },
  computed: {

    truckType() {
      return truckTypes()[ this.requestExtras.truckType];
    },

  },
  methods:{
    getLoadTypeName(key) {
      return getLoadTypeName(key);
    },
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>